angular.module('skeyenoteWebApp').controller('ConfigurationCtrl', ConfigurationCtrl);

function ConfigurationCtrl($scope, $http, baseUrlSrv, ngToast) {
  'ngInject';

  $scope.configrations = [];
  ngToast.dismiss();

  let getConfigurations = function() {
    $http.get(baseUrlSrv.getRestApiBase() + '/configurations/all')
    .success(function(data, status, headers, config) {
      $scope.configurations = data.body;
    })
    .error(function(data, status, headers, config) {
      if (status === 401) {
        ngToast.danger({
          content: 'You don\'t have permission on this page',
          verticalPosition: 'bottom',
          timeout: '3000',
        });
        setTimeout(function() {
          window.location = baseUrlSrv.getBase();
        }, 3000);
      }
      console.log('Error %o %o', status, data.message);
    });
  };

  let init = function() {
    getConfigurations();
  };

  init();
}
